import React, { useLayoutEffect } from 'react';
import './JobsScreen.less';
import { useDispatch, useSelector } from 'react-redux';
import { jobsActions, jobsSelectors } from '../../redux/jobs';
import Loading from '../../components/common/Loading/Loading';
import JobList from './components/JobList/JobList';
import { useParams } from 'react-router';
import SideBarLayout from '../MainScreen/SideBarLayout';
import JobDetails from './components/JobDetails/JobDetails';
import JobSearchToolbarItem from './components/JobFilterToolbar/JobSearchToolbarItem';
import JobStatistics from './components/JobStatistics/JobStatistics';
import { useIsCompactLayout } from '../../helper/LayoutHelper';
import BasicScreen from '../common/BasicScreen/BasicScreen';
import { useTranslation } from 'react-i18next';
import JobDetailsAddUnknown from './components/JobDetailsAddUnknown/JobDetailsAddUnknown';
import { push } from 'redux-first-history';
import { Helmet } from 'react-helmet-async';
import { applicationSelectors } from '../../redux/application';
import JobFilterToolbar from './components/JobFilterToolbar/JobFilterToolbar';

const JobsScreen = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const preselectedJobId = useSelector(jobsSelectors.getPreselectedJobId);

    useLayoutEffect(() => {
        dispatch(jobsActions.loadJobs());

        if (preselectedJobId) {
            dispatch(push(`/ablesung/${preselectedJobId}`));
        }
    }, [preselectedJobId]);

    const isLoading = useSelector(jobsSelectors.isLoading);
    const jobs = useSelector(jobsSelectors.getFilteredJobs);

    const isCompactLayout = useIsCompactLayout();

    // Routes: /ablesung (list), /ablesung/neu (unknown meter), /ablesung/:jobId (details)
    const { jobId } = useParams<{ jobId?: string }>();
    const view = !jobId ? 'list' : jobId === 'neu' ? 'new' : 'details';

    const applicationName = useSelector(applicationSelectors.getApplicationName);

    return (
        <>
            <Helmet>
                <title>{applicationName} | Ablesung</title>
            </Helmet>
            {isLoading && (
                <div className={'flex-1 p-4'}>
                    <Loading size={50} text={t('common.loadingReadings')} />
                </div>
            )}

            {!isLoading && !isCompactLayout && (
                <SideBarLayout
                    sidebar={
                        <BasicScreen>
                            <JobFilterToolbar />
                            <JobList />
                        </BasicScreen>
                    }
                >
                    {view === 'list' && <JobStatistics jobs={jobs} />}
                    {view === 'new' && <JobDetailsAddUnknown />}
                    {view === 'details' && jobId && <JobDetails jobId={jobId} />}
                </SideBarLayout>
            )}

            {!isLoading && isCompactLayout && view === 'list' && (
                <BasicScreen>
                    <JobFilterToolbar />
                    <JobList className={''} />
                </BasicScreen>
            )}
            {!isLoading && isCompactLayout && view === 'new' && <JobDetailsAddUnknown />}
            {!isLoading && isCompactLayout && view === 'details' && jobId && <JobDetails className={'w-full p-2'} jobId={jobId} />}
        </>
    );
};

export default JobsScreen;
